<div class="dialog-header">
  <h2>Refund</h2>
  <button class="x-btn" (click)="close()">&#10005;</button>
</div>

<div class="dialog-body">
  <div class="form-group">
    <label>Administrative expenses</label>
    <input type="number" [(ngModel)]="form.administrativeExpenses" />
  </div>
</div>

<div class="dialog-footer">
  <button class="close-btn" (click)="close()">Close</button>
  <button class="submit-btn" (click)="submit()">Submit</button>
</div>
